import { ShippingOption } from "@Types/addresses";
import { CheerzApiShippingOption } from "@Types/api/addresses";
import { convertFromApiToPrice, convertFromPriceContentToApi } from "./price";

export const convertFromShippingOptionContentToApi = (
  contentOption: ShippingOption
): CheerzApiShippingOption => {
  return {
    available: contentOption.available !== true ? false : true,
    delivery_dates: contentOption.deliveryDates ? contentOption.deliveryDates : null,
    price: contentOption.price ? convertFromPriceContentToApi(contentOption.price) : null,
    selected: contentOption.selected,
  };
};

export const convertFromApiToShippingOption = (
  jsonOption: CheerzApiShippingOption
): ShippingOption => {
  return {
    available: jsonOption.available !== true ? false : true,
    deliveryDates: jsonOption.delivery_dates ? jsonOption.delivery_dates : undefined,
    price: jsonOption.price ? convertFromApiToPrice(jsonOption.price) : undefined,
    selected: jsonOption.selected,
  };
};
